
const buttonLabel =
    `<svg width="80px" height="18px" viewBox="0 0 80 18" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="igv-navbar-button-group">
            <rect id="Rectangle" x="0.5" y="0.5" width="79" height="17" rx="6"></rect>
            <text id="igv-text-button-label" x="50%" y="50%" dy=".1em" font-family="Helvetica" font-size="12" font-weight="normal" letter-spacing="-0.372">
                <tspan id="igv-navbar-button-label"></tspan>
            </text>
        </g>
    </g>
</svg>`

const sampleNameButtonLabel =
    `<svg width="90px" height="20px" viewBox="0 0 90 20" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="igv-navbar-button-group">
            <rect id="Rectangle" x="0.5" y="0.5" width="89" height="18" rx="6"></rect>
            <text id="igv-text-button-label" x="50%" y="50%" dy=".1em" font-family="Helvetica" font-size="12" font-weight="normal" letter-spacing="-0.372">
                <tspan id="igv-navbar-button-label"></tspan>
            </text>
        </g>
    </g>
</svg>`

export { buttonLabel, sampleNameButtonLabel }
